import { cn } from '@/lib/utils';

interface PriceBarProps {
  yesPrice: number;
  className?: string;
  showLabels?: boolean;
}

export function PriceBar({ yesPrice, className, showLabels = true }: PriceBarProps) {
  const yesPercent = Math.round(yesPrice * 100);
  const noPercent = 100 - yesPercent;

  return (
    <div className={cn('w-full', className)}>
      <div className="flex h-10 overflow-hidden rounded-lg border border-border">
        <div
          className="flex items-center justify-center bg-emerald-500 text-white font-semibold text-sm transition-all"
          style={{ width: `${yesPercent}%` }}
        >
          {showLabels && yesPercent > 15 && <span>YES {yesPercent}%</span>}
        </div>
        <div
          className="flex items-center justify-center bg-red-500 text-white font-semibold text-sm transition-all"
          style={{ width: `${noPercent}%` }}
        >
          {showLabels && noPercent > 15 && <span>NO {noPercent}%</span>}
        </div>
      </div>
    </div>
  );
}
